import React, { useMemo, useEffect, useState } from "react";
import { gql, useQuery, useLazyQuery } from "@apollo/client";
import SchoolWeekSelector from "../../Components/schoolWeekSelector";
import StudentWeekView from "../../Components/studentWeekView";


const TODAY_QUERY = gql`
    query GetToday {
        today {
            date
            weekNumber
            holiday {
                name
            }
        }
    }
`;

const STUDENT_WEEK_QUERY = gql`
    query GetMyWeek($weekNumber: Int!) {
        getMyWeek(weekNumber: $weekNumber) {
            stats {
                exits
                studies
            }
        }
    }
`;

const ME_QUERY = gql`
    query Me {
        me {
            __typename
            ... on Student {
                id
                class {
                    id
                    stats {
                        exits
                        studies
                    }
                }
            }
        }
    }
`;

export default function StudentDashboard() {
    const [weekNumber, setWeekNumber] = useState(0);
    const { data: today, loading: todayLoading, error: todayError } = useQuery(TODAY_QUERY);
    const [loadStudentWeek, { data: studentWeekData, loading: studentWeekLoading }] = useLazyQuery(STUDENT_WEEK_QUERY);
    const [loadMe, { data: meData, loading: meLoading }] = useLazyQuery(ME_QUERY);

    useEffect(() => {
        if (today) {
            setWeekNumber(today.today.weekNumber);
        }
    }, [today]);

    useEffect(() => {
        if (weekNumber) {
            loadStudentWeek({ variables: { weekNumber } });
        }
    }, [weekNumber, loadStudentWeek]);

    useEffect(() => {
        loadMe();
    }, [loadMe]);

    const [studentWeekExits, setStudentWeekExits] = useState(0);
    const [studentWeekStudies, setStudentWeekStudies] = useState(0);

    function setStats(exits, studies) {
        setStudentWeekExits(exits);
        setStudentWeekStudies(studies);
    }

    if (todayLoading || studentWeekLoading || meLoading) return <p>Loading...</p>;
    if (todayError) return <p>Error: {todayError.message}</p>;



    return (
        <>
            <section className="flex justify-between items-center space-x-4 my-3">
                <SchoolWeekSelector 
                        selectedWeek={weekNumber}
                        onWeekChange={setWeekNumber}
                    />
                
                <div className="text-lg text-gray-700 text-right hidden md:block">
                    <p className="text-md ">
                        Ausgänge: <span className="font-bold">{studentWeekExits} / {meData.me.class.stats.exits}</span>
                    </p>
                    <p className="text-md ">
                        Studien: <span className="font-bold">{studentWeekStudies} / {meData.me.class.stats.studies}</span>
                    </p>
                </div>
            </section>
            <div className="text-lg block md:hidden text-gray-700 text-right w-full mb-4">
                    <p className="text-md ">
                        Ausgänge: <span className="font-bold">{studentWeekExits} / {meData.me.class.stats.exits}</span>
                    </p>
                    <p className="text-md ">
                        Studien: <span className="font-bold">{studentWeekStudies} / {meData.me.class.stats.studies}</span>
                    </p>
            </div>
            <section className="flex flex-col md:flex-row gap-4">
                <StudentWeekView weekIndex={weekNumber} setStats={setStats} />
            </section>
        </>
    );
}
